import { p as proxyCustomElement, H, h, d as Host } from './p-BJEvNVLM.js';

const cosmosIconCss = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}";

const CosmosIconViewMore$1 = /*@__PURE__*/ proxyCustomElement(class CosmosIconViewMore extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
    }
    getRole() {
        return this.ariaLabel ? 'img' : undefined;
    }
    getAriaHidden() {
        return this.ariaLabel ? false : 'true';
    }
    render() {
        return (h(Host, { key: 'c298c296e430e8e09a756b94066a9c6e58f62a30', role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h("svg", { key: '9117df57196ba326ce987ca2dced2cd7c5a05b0a', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h("path", { key: '21c3f64049693baa99a1ebff7bb76b5a9d7a4c75', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M11.022 4.001a1.52 1.52 0 0 1 0 3.04 1.466 1.466 0 0 1-1.52-1.52 1.466 1.466 0 0 1 1.52-1.52m0 5.48a1.52 1.52 0 1 1 0 3.04 1.52 1.52 0 0 1 0-3.04m1.52 6.999a1.52 1.52 0 1 0-3.041 0 1.52 1.52 0 0 0 3.04 0", fill: "currentColor" }))));
    }
    static get style() { return cosmosIconCss; }
}, [1, "cosmos-icon-view-more", {
        "ariaLabel": [513, "aria-label"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-icon-view-more"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-icon-view-more":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosIconViewMore$1);
            }
            break;
    } });
}

const CosmosIconViewMore = CosmosIconViewMore$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosIconViewMore, defineCustomElement };
